import PropTypes from "prop-types";
import { Media } from "solar/components/Media";
import Save from "components/shared/stays/Save";
import Share from "components/shared/stays/Share";
import styles from "components/stay/Hero.module.scss";

/**
 * @param {node} children - Child components to render inside of wrapper
 */

export default function Hero({ tripID, children }) {
  return (
    <div className={styles.component}>
      <div className={styles.grid}>{children}</div>
      <Media greaterThanOrEqual="lg">
        <div className={styles.actions}>
          <Share type="trip" />
          <Save tripID={tripID} isListing />
        </div>
      </Media>
    </div>
  );
}

Hero.propTypes = {
  tripID: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
